'use client';
import React, { forwardRef, ComponentPropsWithRef } from 'react';

/**
 * 共通インプット
 */
const Input = forwardRef((props: ComponentPropsWithRef<'input'>, ref: React.ForwardedRef<HTMLInputElement>) => {
  const { className, ...rest } = props;

  const defaultClassName =
    'bg-gray-50 text-gray-900 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500';

  // デフォルトのCSSクラスとユーザーが指定したクラスをマージ
  const mergedClassName = `${defaultClassName} ${className || ''}`.trim();

  return <input ref={ref} className={mergedClassName} {...rest} />;
});

Input.displayName = 'Input';

export default Input;
